import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { UseFormPayload } from '@domain-group/react-hooks'

import { Box, Form, Link } from '@domain-group/suit-theme'

import type { ProviderModel } from '@models/types'

import ProviderTile from '../ProviderTile'

interface ProviderTileProps {
  formPayload: UseFormPayload,
  providers: ProviderModel[],
}

const ProviderTiles = (props: ProviderTileProps) => {
  const { formPayload, providers } = props

  const { entityState: { selectedProviderId }, setEntityState } = formPayload

  return (
    <Box marginTop="large" flexDirection="column">
      <Form.Field
        label={selectedProviderId ? 'Selected Provider' : '* Select Provider'}
        labelRight={!!selectedProviderId && (
          <Link
            onClick={() => setEntityState({ selectedProviderId: null })}
            textProps={{ fontSize: 'xsmall' }}
          >
            Edit Provider
            <FontAwesomeIcon icon={faPencil} style={{ marginLeft: '4px' }} />
          </Link>
        )}
      >
        {!!selectedProviderId && (
          <ProviderTile key={selectedProviderId} isSelected formPayload={formPayload} providerId={selectedProviderId} />
        )}

        {!selectedProviderId && providers.map(provider => (
          <ProviderTile
            key={provider.id}
            formPayload={formPayload}
            providerId={provider.id}
          />
        ))}
      </Form.Field>
    </Box>
  )
}

export default ProviderTiles
